<template>
  <div v-if="filteredProducts" class="main">
    <Loading :visible="loading" type="fullPage" size="large" />
    <div class="productList" v-if="Object.keys(filteredProducts).length > 0">
      <ProductListItem :item="filteredProducts[id]" v-for="id in filteredOrder" :key="id" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Loading from '../Loading.vue';
import { setPageTitle } from '../../lib/pageTitle';
import ProductListItem from './ProductListItem.vue';
import { useSeoMeta } from '@unhead/vue';

export default {
  name: 'ProductList',
  data() {
    return {
      maxImageHeight: 0,
      navName: '',
    };
  },
  components: {
    Loading,
    ProductListItem,
  },
  computed: {
    ...mapState({
      loading: (state) => state.products.isLoading,
      language: (state) => state.language,
      currencySymbol: (state) => state.app.currencySymbol,
      order: (state) => state.products.order,
      userLoaded: (state) => state.user.loaded,
      publicURL: (state) => state.app.API_PUBLIC_URL,
      meta: (state) => state.meta.data,
      navTranslations: (state) => state.app.navTranslations,
    }),
    filteredOrder() {
      const filteredOrder = this.order.filter((id) => {
        return this.filteredProducts[id];
      });
      return filteredOrder;
    },
    ...mapGetters({
      filteredProducts: 'products/filteredList',
    }),
  },
  methods: {
    getNavName(type) {
      if (typeof this.navTranslations !== 'undefined') {
        if (typeof this.navTranslations[type] !== 'undefined') {
          if (
            typeof this.navTranslations[type][this.language] !== 'undefined' &&
            this.navTranslations[type][this.language] !== ''
          ) {
            return this.navTranslations[type][this.language];
          }
        }
      }
      return this.$t(type);
    },
    setMeta() {
      let title = '';
      let description = '';
      let keywords = '';
      let image = '';
      if (typeof this.meta !== 'undefined') {
        if (typeof this.meta.merchandise !== 'undefined') {
          description = this.meta.merchandise.description;
          keywords = this.meta.merchandise.keywords;
          if (this.meta.merchandise.image) {
            image = `${this.publicURL}1200/${this.meta.merchandise.image}`;
          }
          title = this.meta.merchandise.title;
        }

        useSeoMeta({
          title: setPageTitle(title),
          ogTitle: setPageTitle(title),
          description,
          keywords,
          ogDescription: description,
          ogImage: image,
        });
      }
    },
  },
  watch: {
    meta() {
      this.setMeta();
    },
  },
  mounted() {
    this.setMeta();
    this.navName = 'NAV_MERCHANDISE';
    if (this.$route.name === 'passes') {
      this.navName = 'NAV_MEMCARD';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/mixins';

.main {
  clear: both;
}

.productList {
  @include blockPadding;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  background-color: $block-color;
  display: flex;
  flex-wrap: wrap;
  @if ($block-color != 'transparent') {
    padding-top: 3 * $sp;
  }
}
</style>
